export default __webpack_public_path__ + "static/media/my-account.3c3ecb18.svg";